module.exports = {"transport":"http","websocket":"wss://api.scoopit.app","uri":"https://api.scoopit.app","url":"","dev_uri":"https://api.scoopit.app","stage_uri":"https://api.scoopit.app","address_prefix":"SCP","chain_id":"069b7c0df670527f0bc41cf12fba0b0a6380eb99b7d66876b7b2bd2cbf3bb447"}


//////////////////
// WEBPACK FOOTER
// ./config.json
// module id = 82
// module chunks = 0 1